import { RouteConfig } from 'vue-router';
import { LazyLoadRoute } from '@shared/router/util';
import { store } from '@shared/store';

export const StreamRoutes: RouteConfig[] = [
    {
        name: 'Stream',
        path: '/',
        component: () => LazyLoadRoute(import('./Stream.vue')),
        beforeEnter(to, from, next) {
            if (store.getters['isAuthenticated'])
                return next();

            return next('/authentication/signin');
        }
    },
];
